import routes from './../../routes';

export const isValidUrl = (url) => {
    return !!routes.find(route => route.path === url);
  };